
const subscript =
{
    '0': '₀', '1': '₁', '2': '₂', '3': '₃', '4': '₄', '5': '₅', '6': '₆', '7': '₇', '8': '₈', '9': '₉',
    '⁰': '₀', '¹': '₁', '²': '₂', '³': '₃', '⁴': '₄', '⁵': '₅', '⁶': '₆', '⁷': '₇', '⁸': '₈', '⁹': '₉',
    'a': 'ₐ', 'b': 'b', 'c': 'c', 'd': 'd', 'e': 'ₑ',
    'f': 'f', 'g': 'g', 'h': 'h', 'i': 'ᵢ', 'j': 'ⱼ',
    'k': 'ₖ', 'l': 'ₗ', 'm': 'ₘ', 'n': 'ₙ', 'o': 'ₒ',
    'p': 'ₚ', 'q': 'q', 'r': 'ᵣ', 's': 'ₛ', 't': 'ₜ',
    'u': 'ᵤ', 'v': 'ᵥ', 'w': 'w', 'x': 'ₓ', 'y': 'ᵧ', 'z': 'z',
    'A': 'A', 'B': 'B', 'C': 'C', 'D': 'D', 'E': 'E',
    'F': 'F', 'G': 'G', 'H': 'H', 'I': 'I', 'J': 'J',
    'K': 'K', 'L': 'L', 'M': 'M', 'N': 'N', 'O': 'ₒ',
    'P': 'P', 'Q': 'Q', 'R': 'R', 'S': 'S', 'T': 'T',
    'U': 'U', 'V': 'V', 'W': 'W', 'X': 'X', 'Y': 'Y', 'Z': 'Z',
    "+": "₊",
    "-": "₋",
    "=": "₌",
    "(": "₍",
    ")": "₎",   
    '⁺':'₊', '⁻':'₋','⁼':'₌','⁽':'₍','⁾':'₎',
    'ᵃ': 'ₐ', 'ᵇ': 'b', 'ᶜ': 'c', 'ᵈ': 'd', 'ᵉ': 'ₑ', 'ᶠ': 'f', 'ᵍ': 'g', 'ʰ': 'ₕ', 'ⁱ': 'ᵢ', 'ʲ': 'ⱼ', 'ᵏ': 'ₖ', 'ˡ': 'ₗ', 'ᵐ': 'ₘ', 'ⁿ': 'ₙ', 'ᴼ': 'ₒ', 'ᵖ': 'ₚ', 'q': 'q', 'ʳ': 'ᵣ', 'ˢ': 'ₛ', 'ᵗ': 'ₜ', 'ᶸ': 'ᵤ', 'ᵛ': 'ᵥ', 'ʷ': 'w', 'ˣ': 'ₓ', 'ʸ': 'y', 'z': 'z',
    'ᴬ': 'A', 'ᴮ': 'B', 'ᶜ': 'C', 'ᴰ': 'D', 'ᴱ': 'E', 'F': 'F', 'ᴳ': 'G', 'ᴴ': 'H', 'ᴵ': 'I', 'ᴶ': 'J', 'ᴷ': 'K', 'ᴸ': 'L', 'ᴹ': 'M', 'ᴺ': 'N', 'ᴼ': 'O', 'ᴾ': 'P', 'Q': 'Q', 'ᴿ': 'R', 'S': 'S', 'ᵀ': 'T', 'ᵁ': 'U', 'ⱽ': 'V', 'ᵂ': 'W', 'X': 'X', 'Y': 'Y', 'ᶻ': 'Z'

}
export default subscript
